const storage = {
    login: 'auth.login',
    remember: 'auth.remember',
    permissions: 'auth.permissions',
};
export default storage;
